import { useLayoutEffect, useState } from "react";
/**
 * Get the initial position of the toolbar. Toolbar size can be `undefined` at first,
 * and we don't want to update the toolbar position multiple times. Therefore, we will
 * wait until we know the size of toolbar and set the `initialPosition` only once.
 *
 * Each `x` and `y` will be 0 if a user doesn't set the default position of each value.
 */
export var useGetInitPosition = function (boundSelector, toolbarSize, defaultPosition) {
    var _a = useState(), initPosition = _a[0], setInitPosition = _a[1];
    useLayoutEffect(function () {
        // Set the initial position only once
        if (initPosition != null) {
            return;
        }
        // Toolbar size will be undefined at first. Wait until we know the size
        if (toolbarSize == null) {
            return;
        }
        // Wait until the bound element exist
        var boundElement = window.document.querySelector(boundSelector);
        if (boundElement == null) {
            return;
        }
        if (defaultPosition == null) {
            setInitPosition({
                x: 0,
                y: 0,
            });
            return;
        }
        var x = 0;
        var y = 0;
        if (defaultPosition.x === "left") {
            x = 0;
        }
        else if (defaultPosition.x === "center") {
            x = boundElement.clientWidth / 2 - toolbarSize.width / 2;
        }
        else if (defaultPosition.x === "right") {
            x = boundElement.clientWidth - toolbarSize.width;
        }
        if (defaultPosition.y === "top") {
            y = 0;
        }
        else if (defaultPosition.y === "middle") {
            y = boundElement.clientHeight / 2 - toolbarSize.height / 2;
        }
        else if (defaultPosition.y === "bottom") {
            y = boundElement.clientHeight - toolbarSize.height;
        }
        setInitPosition({
            x: x,
            y: y,
        });
    }, [
        toolbarSize === null || toolbarSize === void 0 ? void 0 : toolbarSize.width,
        toolbarSize === null || toolbarSize === void 0 ? void 0 : toolbarSize.height,
        defaultPosition === null || defaultPosition === void 0 ? void 0 : defaultPosition.x,
        defaultPosition === null || defaultPosition === void 0 ? void 0 : defaultPosition.y,
    ]);
    return initPosition;
};
